import { flattenObject } from '../../src/client/util/flatten';

export const trackingAttributesMapping = {
    navigation: {
        myDigitalSubscription: 'my_subscription',
        privacySettings: 'privacy_settings',
        changeProfile: 'change_profile',
    },
    mypage: {
        subscriptions: {
            cancelSubscription: 'cancel_subscription',
            changePaymentMethod: 'change_payment',
            buySubscription: 'buy_subscription',
            reactivateSubscription: 'reactivate_subscription',
            reactivateSuccess: 'reactivate_success',
            confirmReactivate: 'reactivate_confirm',
            cancelReactivate: 'reactivate_cancel',
            shareSubscription: 'share_subscription',
            invoices: 'invoices',
            invoiceFile: 'invoice_file',
            manageDelivery: 'manage_delivery',
            changeProduct: 'change_product',
        },
        sharing: {
            sendInvitation: 'sendInvitation',
            acceptInvitation: 'acceptInvitation',
            acceptInvitationError: 'acceptInvitationError',
            acceptInvitationSuccess: 'acceptInvitationSuccess',
            sendInvitationSuccess: 'sendInvitationSuccess',
            sendInvitationError: 'sendInvitationError',
            sendSMSInvitation: 'sendSMSInvitation',
            sendSMSInvitationSuccess: 'sendSMSInvitationSuccess',
            sendSMSInvitationError: 'sendSMSInvitationError',
            removeInvitation: {
                ACTIVE: {
                    action: 'deleteActiveInvite',
                    success: 'deleteActiveInviteSuccess',
                    error: 'deleteActiveInviteError',
                },
                PENDING: {
                    action: 'deletePendingInvite',
                    success: 'deletePendingInviteSuccess',
                    error: 'deletePendingInviteError',
                },
            },
            quitSharedSubscription: 'quitSharedSubscription',
            quitSharedSubscriptionSuccess: 'quitSharedSubscriptionSuccess',
            quitSharedSubscriptionError: 'quitSharedSubscriptionError',
        },
        deliveries: {
            permanentDeliveryAddressChanged: 'permanentDeliveryAddressChanged',
            temporaryDeliveryAddressChanged: 'temporaryDeliveryAddressChanged',
            pauseDeliveryConfirmed: 'pauseDeliveryConfirmed',
            submitComplaint: 'submitComplaint',
            changeTemporaryDelivery: 'changeTemporaryDelivery',
            changeTemporaryPauseDelivery: 'changeTemporaryPauseDelivery',
            changePermanentDelivery: 'changePermanentDelivery',
            changeDeliveryBooking: 'changeDeliveryBooking',
            editDeliveryDate: 'editDeliveryDate',
            choosePermanentDeliveryAddress: 'choosePermanentDeliveryAddress',
            chooseTemporaryDeliveryAddress: 'chooseTemporaryDeliveryAddress',
            chooseDeliveryDates: 'chooseDeliveryDates',
            deleteDeliveryBookingStep1: 'deleteDeliveryBookingStep1',
            deleteDeliveryBookingConfirmation: 'deleteDeliveryBookingConfirmation',
        },
        newsletters: {
            subscribe: 'newsletterSubscribe',
            unsubscribe: 'newsletterUnsubscribe',
            subscribeError: 'newsletterSubscribeError',
            unSubscribeError: 'newsletterUnsubscribeError',
            subscribeRedirectToLogin: 'newsletterSubscribeRedirectToLogin',
            subscribeShowActionRequiredModal: 'newsletterSubscribeShowActionRequiredModal',
        },
        externalLink: 'external_link',
    },
    privacy: {
        privacyControls: 'privacy_controls',
        changesToPrivacy: 'privacy_updates',
        smartAds: 'about_smartads',
    },
};

export const getElementTrackingId = elementId => flattenObject(trackingAttributesMapping)[elementId];
